export const FLARE_CHAIN_ID = 14;
export const FLARE_RPC_URL = "https://flare-api.flare.network/ext/C/rpc";
export const FLARE_PUBLIC_RPC_URLS = [
  FLARE_RPC_URL,
  "https://stylish-light-theorem.flare-mainnet.quiknode.pro/ext/bc/C/rpc",
] as const;
export const FLARE_EXPLORER_URL = "https://flare-explorer.flare.network";
export const FLARE_CONTRACTS_REGISTRY = "0xaD67FE66660Fb8dFE9d6b1b4240d8650e30F6019" as const;
export const BURN_ADDRESS = "0x000000000000000000000000000000000000dEaD" as const;
export const FIRE_RESERVE_SOURCES = [
  { label: "FDC request fees", address: "0x0ce6831DF00A6018c4d316009980DbAa6c44E525", asset: "FLR / WFLR", description: "Settled FIRE share of fees paid for verified FDC requests." },
  { label: "FXRP minting fees", address: "0xF55bcAd5568d1584ab6f013f144e1e433Ee551C7", asset: "FXRP", description: "FXRP collected from direct minting activity through the FAssets system." },
  { label: "Minting tag fees", address: "0x889A02c0E6d92e77188aDe03e3ce15B73228C197", asset: "FLR / WFLR", description: "FLR paid when reusable FXRP minting destination tags are reserved." },
  { label: "FXRP redemption fees", address: "0x6E815bB968e32f91C7e273b9e1CDAE2825Bf8F3a", asset: "FXRP", description: "FXRP collected from redemption activity through the FAssets system." },
] as const;
export const FLR_USD_FEED_ID = "0x01464c522f55534400000000000000000000000000" as const;
export const XRP_USD_FEED_ID = "0x015852502f55534400000000000000000000000000" as const;
export const FIP16_ACCEPTED_AT = "2026-04-24T00:00:00.000Z";
export const FIP16_FEE_ACTIVATED_AT = "2026-07-14T12:00:00.000Z";
export const WEI_PER_FLR = 10n ** 18n;

export const RANGE_OPTIONS = ["24h", "7d", "30d", "90d", "reward-cycle", "since-fip16", "custom"] as const;
export type RangeKey = (typeof RANGE_OPTIONS)[number];
